// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"b68f83ab","488":"54773bdc","730":"961154c9","957":"b111fede"}[chunkId] + ".chunk.js";
};